export default __webpack_public_path__ + "static/media/dr-white-room-copy.927c5a4f.jpg";